import { all, call, takeLeading, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { retrieveFromLocalStorage } from '../../utils/util';

import { requestViewEWalletEntries } from './e-wallet.actions';
import { getViewEWalletEntriesRequest } from './e-wallet.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setEntries } from '../../slices/e-wallet/e-wallet.slice';

export function* performViewEWalletEntriesRequest() {
  try {
    yield put(addSpinner('Retrieving Entries'));

    const personExternalReference = retrieveFromLocalStorage('personExternalReference');

    const [endpoint, options] = getViewEWalletEntriesRequest(personExternalReference);

    const { data } = yield call(axios, endpoint, options);

    yield put(setEntries(data.accountOverviewVOS));
  } catch (error) {
    yield put(setEntries([]));
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving Entries'));
  }
}

export function* watchForViewEWalletEntriesRequest() {
  yield takeLeading(requestViewEWalletEntries.type, performViewEWalletEntriesRequest);
}

export default function* eWalletSaga() {
  yield all([watchForViewEWalletEntriesRequest()]);
}
